{
  "preview_error": "Failed to load session preview",
  "steps": "Steps",
  "load_error": "Failed to load session",
  "step_not_found": "Step not found",
  "next": "Next",
  "continue": "Continue",
  "finish": "Finish",
  "exit": "Exit",
  "finish_heading": "Well done {{name}}.",
  "finish_subheading": "All steps finished!",
  "back_to_dashboard": "Back to dashboard",
  "back_to_library": "Back to library"
}
